<template>
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.51608 15.9902C7.61636 17.0907 7.61647 18.8744 6.51608 19.9749C5.42006 21.0709 0.998216 21.5407 0.961755 21.5445C0.961755 21.5445 1.43022 17.0902 2.53077 15.9896C3.63134 14.8891 5.41555 14.8896 6.51608 15.9902Z"
            fill="currentColor" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M22.2622 0.690242C23.0438 3.74148 22.1745 9.4457 16.1738 15.0619C16.2141 16.8562 15.7623 19.9194 13.6971 22.3439C13.6112 22.4443 13.4494 22.4031 13.4181 22.2748L12.4088 18.0738C12.0997 18.2871 11.7825 18.5004 11.4559 18.7117C11.2935 18.8168 11.0753 18.7953 10.9384 18.6587L3.84647 11.5667C3.70965 11.4299 3.68889 11.2122 3.79398 11.0498C4.02108 10.6988 4.24935 10.358 4.47864 10.0273L0.125325 8.98208C-0.00326506 8.95097 -0.0442962 8.78902 0.0562881 8.70308C2.57287 6.5594 5.77719 6.15289 7.5368 6.23202C13.3437 0.0873829 19.2282 -0.593876 22.1623 0.342776L22.2622 0.690242ZM17.8261 4.67898C16.9044 3.75752 15.41 3.75736 14.4884 4.67898C13.5668 5.60059 13.567 7.095 14.4884 8.01671C15.4101 8.93829 16.9045 8.93836 17.8261 8.01671C18.7478 7.09505 18.7477 5.60067 17.8261 4.67898Z"
              fill="currentColor" />
    </svg>
</template>
<script>
export default {
    name: "AutomationIcon",
};
</script>
<style scoped></style>
